import React from 'react';

import svg from './assets/icons-32-account-circle.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconUserSolid = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-user-solid" />
);
